/* eslint-disable max-len */
import React from 'react';
import {
    ShimmerBadge,
    ShimmerButton,
    ShimmerText,
    ShimmerThumbnail,
} from 'react-shimmer-effects';

export default function Shimmer() {
    return (
        <div className="max-h-[420px]">
            {[...Array(3)].map((_, index) => (
                <div key={index} className="overflow-y-auto mb-[32px]">
                    {/* Invoice header */}
                    <div className="flex justify-between h-[68px] roundeds bg-[#EEF7FE] w-full border border-[#c2dcef]">
                    </div>
                    {/* Invoice Body */}
                    <div className="flex mx-[12px] my-[7px]">
                        {/* Items */}
                        <div className="w-[63%] border border-[#e6e8ea] max-h-[200px]">
                            {/* Items header */}
                            <div className="flex bg-[#e6e8ea] h-12 items-center">
                                <div className="ml-[14px]">
                                    <p className=" text-[#031624] font-semibold leading-6">
                                        <ShimmerText width={120} />
                                    </p>
                                </div>
                            </div>
                            {/* Items Body */}
                            <div className="mt-[4px] mb-[8px]">
                                <div className=" min-h-[72px]">
                                    <div className="flex" >
                                        <div className="flex">
                                            <p
                                                className="ml-[20px] text-[#031624] leading-6 break-all min-w-[150px] 2xl:min-w-[120px]"
                                                id="item_name"
                                                data-testid={index + 'name'}
                                            >
                                                <ShimmerText width={10} />
                                            </p>
                                            <p
                                                className="ml-[20px] 2xl:ml-[25px] pl-4 min-w-[80px] 2xl:min-w-[100px] text-[#031624] leading-6 text-start"
                                                id="quantity"
                                                data-testid={index + 'quantity'}
                                            >
                                                <ShimmerText width={80} />
                                            </p>
                                            <p
                                                className="ml-[20px] 2xl:ml-[25px] min-w-[80px] 2xl:min-w-[100px] text-[#031624] leading-6 text-start"
                                                id="charge"
                                                data-testid={index + 'charge'}
                                            >
                                                <ShimmerText width={80} />
                                            </p>
                                            <p
                                                className="ml-[20px] 2xl:ml-[25px] min-w-[80px] 2xl:min-w-[100px] text-[#031624] leading-6 text-end"
                                                id="total"
                                                data-testid={index + 'total'}
                                            >
                                                <ShimmerText width={80} />
                                            </p>
                                            <p
                                                className="ml-[20px] 2xl:ml-[25px] min-w-[80px] 2xl:min-w-[100px] text-[#031624] leading-6 text-end mr-[16px]"
                                                id="balance"
                                                data-testid={index + 'balance'}
                                            >
                                                <ShimmerText width={80} />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* payments */}
                        <div className="w-[40%] border border-[#e6e8ea] ml-[17px] max-h-[200px]">
                            {/* Payments header */}
                            <div>
                                <div className="flex bg-[#e6e8ea] h-12 items-center">
                                    <p className=" text-[#031624] font-semibold leading-6 ml-[22px]">
                                        <ShimmerText width={180} />
                                    </p>
                                </div>
                            </div>
                            {/* Payments Body */}
                            <div className="mt-[4px] mb-[8px]">
                                <div>
                                    <div className="flex min-h-[108px]">
                                        <div className="flex ml-[25px]">
                                            <p
                                                className="min-w-[90px] 2xl:min-w-[110px] text-[#031624] leading-6 text-end mr-[16px]"
                                                id="payment_date"
                                                data-testid={index + 'payment_date'}
                                            >
                                                <ShimmerText width={80} />
                                            </p>
                                            <p
                                                className="min-w-[80px] 2xl:min-w-[100px] text-[#031624] leading-6 text-end mr-[16px] ml-[150px]"
                                                id="payment_amount"
                                                data-testid={index + 'payment_amount'}
                                            >
                                                <ShimmerText width={80} />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
